import { render, staticRenderFns } from "./ScriveTemplateManagement.vue?vue&type=template&id=16775720&"
import script from "./ScriveTemplateManagement.vue?vue&type=script&lang=ts&"
export * from "./ScriveTemplateManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports